import { render, staticRenderFns } from "./PrivateLocations.vue?vue&type=template&id=1b975444&"
import script from "./PrivateLocations.vue?vue&type=script&lang=js&"
export * from "./PrivateLocations.vue?vue&type=script&lang=js&"
import style0 from "./PrivateLocations.vue?vue&type=style&index=0&id=1b975444&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports